(function () {
    'use strict';

    angular
        .module('recomModule')
        .constant('recomConstants', {
            featureRoles: ['RecomGrpBusinessUnit_Recom_GovernanceManagement',
                'RecomGrpBusinessUnit_Recom_InternalAuditManagement',
                'RecomGrpBusinessUnit_Recom_ComplianceManagement',
                'RecomGrpBusinessUnit_Recom_RealEstateManagement',
                'RecomGrpBusinessUnit_Recom_BIS',
                'RecomGrpBusinessUnit_Recom_InformationSecurityMandate',
                'RecomGrpBusinessUnit_Recom_VendorAssessmentRecommendation',
                'RecomGrpBusinessUnit_Recom_DerogationException',
                'RecomGrpBusinessUnit_Recom_BTGMandate']
        });

})();